import {PageLink} from '../../../../_metronic/layout/core'
import {useIntl} from 'react-intl'

export const CompanyPageBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export const CompanyPageBreadcrumbs = () => {
  const {formatMessage} = useIntl()

  const CompanyPageBreadCrumbs: Array<PageLink> = [
    {
      title: formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  return {
    CompanyPageBreadCrumbs,
  }
}

export const leadInvestor = [
  {
    id: 1,
    name: 'Yes',
    value: 'YES',
  },
  {
    id: 2,
    name: 'No',
    value: 'NO',
  },
]

export enum membersType {
  ADVISOR = 'advisor',
  BOARDMEMBER = 'board_member',
}
